import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  width: 100%;
  gap: 24px;
`;
